export default {
  EUR: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  GBP: {
    currency: {
      style: 'currency',
      currency: 'GBP'
    }
  },
  CHF: {
    currency: {
      style: 'currency',
      currency: 'CHF'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/numberFormats.js